export default "__VITE_ASSET__pYaW621c__"